/**
 * @file 申诉
 * @author zhaomiaoyuan
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import FeedbackStep from './step';
import {fetchCreateTopic} from '../../actions/homeAction';
import {fetchV1Search} from '../../actions/searchAction';
import AppealMajor from '../appeal/appealMajor';
import {
    fetchUserInfo
} from '../../actions/attestAction';
import {Carousel} from 'antd';
import {handleLogin, recordProxy, getUrlValue} from '../../util';

import './feedback.less';

class Feedback extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            value: '',
            off: false,
            phone: '',
            pageObj: {},
            datatype: getUrlValue('datatype')
        };
    }

    componentDidMount() {
        handleLogin(this.props.fetchUserInfo);
        window.scrollTo(0, 0);
        const pagef = getUrlValue('pagef') || 'nopagef';
        const param = {
            datatype: this.state.datatype,
            pagef
        };
        recordProxy('feedbackentry', 'enter', JSON.stringify(param));
    }

    render() {
        const {datatype} = this.state;
        if (datatype === '1' || datatype === '2') {
            return (
                <div className={'feedback-major'}>
                    <div className="banner">
                        <Carousel className="custom-carousel-class" autoplay>
                            <div className="carousel-item">
                                <div className="item-info-wrapper">
                                    <p className="title">号码申诉反馈</p>
                                    <p className="title-tip">号码错误、占用、空号等问题申诉及反馈</p>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                    <div className="appeal-content">
                        <FeedbackStep {...this.props} datatype={datatype} />
                    </div>
                </div>
            );
        } else {
            return <AppealMajor />;
        }
    }
}

Feedback.propTypes = {
    history: PropTypes.object,
    fetchAppealSearch: PropTypes.func,
    feedbackData: PropTypes.object,
    fetchUserInfo: PropTypes.func
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo,
        feedbackData: state.feedbackReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCreateTopic: (type, obj) => fetchCreateTopic(dispatch, type, obj),
        fetchV1Search: (obj) => fetchV1Search(dispatch, obj),
        fetchUserInfo: obj => fetchUserInfo(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Feedback));
